import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import CardItemComponent from '../../../../../core/components/card-item-component';

import {
  Text,
  Image,
  ContainerImageName,
} from './styles';

const Item = (props) => {
  const { item, hideCardName } = props;

  const {
    name,
    description,
    imageUrl,
  } = item;

  return (
    <CardItemComponent
      hasTooltip={!!description && !_.isEmpty(description)}
      tooltipContent={description}
      hasMargin
    >
      <ContainerImageName>
        {(!hideCardName || !imageUrl) && (
          <Text>{name}</Text>
        )}
        {imageUrl && (
          <Image
            src={imageUrl}
            alt={name}
          />
        )}
      </ContainerImageName>
    </CardItemComponent>
  );
};

Item.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
  }).isRequired,
  hideCardName: PropTypes.bool.isRequired,
};

export default Item;
